import React, { useContext, useMemo, useRef } from "react";
import { useState, useEffect } from 'react';
import FileDownloadIcon from '@mui/icons-material/FileDownload'
import { mkConfig, generateCsv, download } from 'export-to-csv';
import { useDispatch } from 'react-redux';
import { getMSID, getToken } from "../common";
import { setCalledFrom, setpKey } from '../store/slices/DocumentClaimSlice';
import { useNavigate } from "react-router-dom";
import { Snackbar, Alert } from "@mui/material";
import { resetScreenshotsTop, resetScreenshotsBottom } from '../store/slices/DocumentClaimSlice';
import useLoader from "../Hook/useLoader";
import Popup from "../Components/Popup";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';


import axios from 'axios';
import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  Tooltip,
  Typography,
} from '@mui/material';
import {
  MaterialReactTable,
  useMaterialReactTable,
} from 'material-react-table';
import { NavLink } from 'react-router-dom';
import { UserContext } from "../Hook/UserContext";
import {
  QueryClient,
  QueryClientProvider,
  useMutation,
  useQuery,
  useQueryClient,
} from '@tanstack/react-query';
import SnackBar from "./SnackBar";
import AppInsight from "../AppInsight";
// import { DATE_VALIDATION_PROP_NAMES } from "@mui/x-date-pickers/internals/utils/validation/extractValidationProps";
import dayjs from "dayjs";


const HomeTable = (props) => {
  const navigate = useNavigate();
  const {userRole,code1,setCode} = useContext(UserContext);
  const [data, setData] = useState(props.data);
  const [show, setShow] = useState(true);
  const [showTable, setShowTable] = useState(false);
  const [statusList, setStatusList] = useState(["Completed", "In-Progress", "Denied", "Approved", "Pending Review", "Sent Back", "QA Done", "Fallout","Request For Approval"]);
  const [rxInstanceList, setRxInstanceList] = useState(["A2_INM", "A2_AZM", "A5_CTR", "A5_KSR", "A6_IRX", "CCTA_PRD", "BOOK1", "BOOK2","A2_TNM","A6_HHS", "A2_IA1", "A2_UT1", "A2_IA2", "A2_UT2"]);

  const [userList, setUserList] = useState(props.userList);
  const [validationErrors, setValidationErrors] = useState({});
  const [editedUsers, setEditedUsers] = useState({});
  const dispatch = useDispatch();
  const [loader, showLoader, hideLoader] = useLoader({ heightOfLoader: '132vh', marginTopLoader: '60%' });
  const [rowSelection, setRowSelection] = useState({});
  const [selectionEnable, setSelectionEnable] = useState(true);
  const [errMessage, setErrMessage] = useState("");
  const alertRef = useRef();
  const [showPopUp, setShowPopUp] = useState(false);
  const [formSubmit, setFormSubmit] = useState(false);
  const isFirstRender = useRef(true);
 

  const [columnFilters, setColumnFilters] = useState(()=>{
    const columnFil=localStorage.getItem('mrt_columnFilters_table_1');
   if(columnFil){
    const parsedFil=JSON.parse(columnFil);
    return parsedFil.map((filter)=>{
      if(filter.id==="Created Date & Time"||filter.id==="Last Update Date & Time"){
        const filterValue=filter.value||[null,null];
        const parsedVal=filterValue.map((val)=>{
          if(val!==null &&val!==undefined){
            return dayjs(val);
          }
          return undefined;
        });
        return {...filter,value:parsedVal};
      }
      return filter;
    })
   }
    return [];
  });
  const [showColumnFilters, setShowColumnFilters] = useState(()=>{
    const columnFil=localStorage.getItem('mrt_showColumnFilters_table_1');
    return columnFil?JSON.parse(columnFil):false;
  });

  const [columnVisibility, setColumnVisibility] = useState(()=>{
    const columnFil=localStorage.getItem('mrt_columnVisibility_table_1');
    return columnFil?JSON.parse(columnFil):{ adjusted_claim_id: false, rts_report: false, violation: false, claim_reference_number: false, file_name: false,pharmacy_adjusted_amount:false,client_adjusted_amount:false};
  });

  const [pagination, setPagination]=useState(()=>{
    const savedPi=localStorage.getItem("pagination");
  
    return savedPi?JSON.parse(savedPi):{pageIndex:0,pageSize:10}
   });




  const handleClosePopup = () => {
    setShowPopUp(false);
    setFormSubmit(true);
  }
 

  useEffect(() => {
    localStorage.setItem(
      'mrt_columnFilters_table_1',
      JSON.stringify(columnFilters),
    );
    localStorage.setItem(
      'mrt_showColumnFilters_table_1',
      JSON.stringify(showColumnFilters),
    );
    localStorage.setItem(
      'mrt_columnVisibility_table_1',
      JSON.stringify(columnVisibility),
    );
    localStorage.setItem(
      'pagination',JSON.stringify(
      pagination)
    );
    // localStorage.setItem(
    //   'PageS',
    //   pagination.pageSize
    // );

  }, [
    columnFilters,showColumnFilters,
    columnVisibility,pagination]);


    const handlePagination=(updater)=>{
      setPagination((prev)=> typeof updater=== 'function'?updater(prev):updater);

    }


  

  const resetState = () => {
    localStorage.removeItem('mrt_columnFilters_table_1');
    localStorage.removeItem('mrt_showColumnFilters_table_1');
    localStorage.removeItem('mrt_columnVisibility_table_1');
    localStorage.removeItem('pagination');
    props.resetDaysAndDateFilterState();
    window.location.reload();
  };

  

  const msid = getMSID();
  const [selectedValue, setSelectedValue] = useState([]);
  const [val, setVal] = useState([]);

  const formateDateString=(dateVar)=>{
    const days=['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
    const months = ['Jan','Feb','March','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

    const date = new Date(dateVar.getTime());

    const day= days[date.getDay()];
    const month= months[date.getMonth()];

    const dayOfMonth= String((date.getDate())).padStart(2,'0');
    const year = String(date.getFullYear());
    const hour = String(date.getHours()).padStart(2, '0');
    const min = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2,'0');
    return `${day}, ${dayOfMonth} ${month} ${year} ${hour}:${min}:${seconds} CST`;
    

  }

  const handleDownloadClaims = (selectedRows) => {
    try {
      let selectedClaimsRow = selectedRows.map((row) => row.original);
      let isClaimInProgress = selectedClaimsRow.some((claim) => claim.status === "In-Progress");
      if (!isClaimInProgress) {
            callDownloadDocumentsAPI(selectedRows);
      }
      else {
        if(alertRef.current)
            alertRef.current.showSnackbar("Unable to download In-Progress Record", 'error');
      }
    }
    catch (error) {
      if(alertRef.current)
          alertRef.current.showSnackbar();
      AppInsight.trackEvent({ name: `PNA Frontend => handleDownloadClaims, msid=> ${msid}`, properties: { errorMessage: error.message } });
    }
  };

  const callDownloadDocumentsAPI = async (selectedRows) => {

    try {
      const token = getToken();
      const selectedClaims = selectedRows.map((row) => row.original.pkey);
      const jsonData = { "keyList": selectedClaims }
      const header = {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        },
        responseType: "blob",
      };
      showLoader();
      AppInsight.trackEvent({ name: `PNA Frontend=>callDownloadDocumentsAPI API Call started, msid=> ${msid}`});
      const response = await axios.post(
        process.env.REACT_APP_API_URI + "MultipleClaimDownload", jsonData, header
      );
      AppInsight.trackEvent({ name: `PNA Frontend=>callDownloadDocumentsAPI API Call completed, msid=> ${msid}`});
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', "merged_word_document.docx")
      document.body.appendChild(link);
      link.click();
      hideLoader();
      document.body.removeChild(link);
    }
    catch (error) {
      if(alertRef.current)
          alertRef.current.showSnackbar();
      hideLoader();
      AppInsight.trackEvent({ name: `PNA Frontend => callDownloadDocumentsAPI, msid=>${msid}`, properties: { errorMessage: error.message } });
    }
  }

  const handleSubmit = () => {
    let selectedRows = table.getSelectedRowModel().rows;
    setSelectedValue(selectedRows);
    const data = selectedRows.map(data => data.original);
    const status = data.some(item => item.status !=='In-Progress'&& item.status !=='Fallout')
    if (status === true) {
      if(alertRef.current)
          alertRef.current.showSnackbar("Record(s) with In-Progress/Fallout status can be deleted only!", "error");
    }
    else {
      const claimNo = data.map((rowData) => rowData.audited_claim_id)
      const commaSeparatedval = claimNo.join('\n');
      setVal(commaSeparatedval);
      setShowPopUp(true);
    }

  }

  const { mutateAsync: updateUsers, isPending: isUpdatingUsers } =
    useUpdateUsers();
  useEffect(() => {
    setShowTable(props.tableValue);
  }, [props.tableValue])
  useEffect(() => {
    setUserList(props.userList);
  }, [])

  useEffect(() => {
    setData(props.data);
  }, [props.data]);

  const csvConfig = mkConfig({
    fieldSeparator: ',',
    decimalSeparator: '.',
    useKeysAsHeaders: true,
  });
  const handleExportData = () => {
    const csv = generateCsv(csvConfig)(data);
    download(csvConfig)(csv);
  };
  const handleExportRows = (rows) => {
    const rowData = rows.map((row) => row.original);
    const csv = generateCsv(csvConfig)(rowData);
    download(csvConfig)(csv);
  };

  const handleExtractedDataFromCheckbox = (rows) => {
    const rowData = rows.map((row) => row.original);

  }

  const handleDeleteClaims = (selectedRows) => {
    try {
      setShowPopUp(false);
        callDeleteClaimsAPI(selectedRows);
    }
    catch (error) {
      if(alertRef.current)
          alertRef.current.showSnackbar();
      AppInsight.trackEvent({ name: `PNA Frontend => handleDeleteClaims, msid=>${msid}`, properties: { errorMessage: error.message } });
    }
  };
  const callDeleteClaimsAPI = async (selectedRows) => {
    try {
      const token = getToken();
      const selectedClaims = selectedRows.map((row) => row.original.pkey);
      const jsonData = { "keyList": selectedClaims ,"manager":msid}
      const header = {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        },
      };
      showLoader();
      AppInsight.trackEvent({ name: `PNA Frontend=>callDeleteClaimsAPI API Call started, msid=> ${msid}`});
      const response = await axios.post(
        process.env.REACT_APP_API_URI + "ClaimDelete", jsonData, header
      );
      AppInsight.trackEvent({ name: `PNA Frontend=>callDeleteClaimsAPI API Call completed, msid=> ${msid}`});
      if (response.data.status === 204) {
        hideLoader();
        if(alertRef.current)
            alertRef.current.showSnackbar("Record deleted successfully", "success");
        const timer = setTimeout(() => {
          window.location.reload();
        }, 3000);
      }

    }
    catch (error) {
      if(alertRef.current)
          alertRef.current.showSnackbar();
      setShowPopUp(false);
      hideLoader();
      AppInsight.trackEvent({ name: `PNA Frontend => callDeleteClaimsAPI, msid=>${msid}`, properties: { errorMessage: error.message } });
    }
  }
  const callDispatch = (rowData) => {
    dispatch(setCalledFrom("Home"));
    dispatch(setpKey(rowData.pkey));
    navigate("/DocumentClaimScreen");
  }

  const [pKey, setpKey] = useState("");


  useEffect(() => {
    if (pKey !== "")
      navigate(`/DocumentClaimScreen/${pKey}`);

  }, [pKey])

  const handleDowloadDocument = async (key) => {
    try {
      callDownloadAPI(key);
    }
    catch (error) {
      if(alertRef.current)
          alertRef.current.showSnackbar();
      AppInsight.trackEvent({ name: `PNA Frontend => handleDownloadDocument, msid=>${msid}`, properties: { errorMessage: error.message } });
    }
  }
  const callDownloadAPI = async (key) => {
    const token = getToken();
    const header = {
      headers: {
        "Authorization": `Bearer ${token}`,
      },
      responseType: "blob"
    };
    //{responseType:'blob',}
    showLoader();
    AppInsight.trackEvent({ name: `PNA Frontend=>callDownloadAPI API Call started, msid=> ${msid}`});
    const response = await axios.get(
      process.env.REACT_APP_API_URI + "ClaimDownload?key=" + key, header
    );
    AppInsight.trackEvent({ name: `PNA Frontend=>callDownloadAPI API Call completed, msid=> ${msid}`});


    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', key + "_final_claim_document.docx")
    document.body.appendChild(link);
    link.click();
    hideLoader();

    document.body.removeChild(link);
  }



  const openDocumentClaim = (pkey) => {
    try {
      dispatch(resetScreenshotsTop());
      dispatch(resetScreenshotsBottom());
      setpKey(pkey);

    }
    catch (error) {

    }
  }
  let columns = useMemo(
    () => [

      {
        accessorKey: 'audited_claim_id', //normal accessorKey
        header: 'Audited Claim#',
        // enableClickToCopy: true,
        minSize: 30,
        maxSize: 30,
        size: 30,
        enableColumnFilter: true,
        Cell: ({ row }) => {
          let claimId = row.original.audited_claim_id;
          return <div>

            <NavLink onClick={() => openDocumentClaim(row.original.pkey)}>{claimId}</NavLink>


          </div>
        },
        enableEditing: false,
      },

      {
        accessorKey: 'audit_claim_seq',
        header: 'Audit Claim Seq',
        minSize: 30,
        maxSize: 30,
        size: 30,
        enableEditing: false,
        Cell: ({ row }) => {
          let claimSeq = row.original.audit_claim_seq;
          return <div style={{paddingLeft:'23%'}}>

            {claimSeq}


          </div>
        },
      },
      {
        accessorKey: 'rxclaim_instance',
        header: 'Rx Instance',
        minSize: 30,
        maxSize: 30,
        size: 30,
        filterVariant: 'select',
        filterSelectOptions: rxInstanceList,
        enableEditing: false,
      },
      {
        accessorKey: 'pharmacy_adjusted_amount', //normal accessorKey
        header: 'Pharmacy Adj Amount',
        minSize: 30,
        maxSize: 30,
        size: 30,
        enableEditing: false,
        Cell: ({ row }) => {
          let value = row.original.pharmacy_adjusted_amount;
          return <div style={{paddingLeft:'23%'}}>
 
            {value}
 
 
          </div>
        },
      },
      {
        accessorKey: 'client_adjusted_amount', //normal accessorKey
        header: 'Client Adj Amount',
        minSize: 30,
        maxSize: 30,
        size: 30,
        enableEditing: false,
        Cell: ({ row }) => {
          let value = row.original.client_adjusted_amount;
          return <div style={{paddingLeft:'23%'}}>
 
            {value}
 
 
          </div>
        },
      },
      {
        accessorKey: 'adjusted_claim_id', //normal accessorKey
        header: 'Adjusted Claim#',
        minSize: 30,
        maxSize: 30,
        size: 30,
        enableEditing: false,
      },
      {
        accessorKey: 'rts_report',
        header: 'RT or Report',
        minSize: 30,
        maxSize: 30,
        size: 30,
        enableEditing: false,
      },
      {
        accessorKey: 'violation',
        header: 'Violation',
        minSize: 30,
        maxSize: 30,
        size: 30,
        enableEditing: false,
      },
      {
        accessorKey: 'claim_reference_number',
        header: 'Claim Reference',
        minSize: 30,
        maxSize: 30,
        size: 30,
        enableEditing: false,
      },
      
      {
        accessorKey: 'status',
        header: 'Status',
        minSize: 170,
        maxSize: 170,
        size: 170,
        filterVariant: 'multi-select',
        filterSelectOptions: statusList,
        Cell: ({ cell }) => (
          <Box
            component="span"
            sx={(theme) => ({
              display: 'flex',
              backgroundColor:
                (cell.getValue() == "Completed" || cell.getValue() == "Approved" || cell.getValue() == "QA Done")
                  ? theme.palette.success.dark
                  :(cell.getValue() == "Denied"||cell.getValue() == "Fallout")?theme.palette.error.main:theme.palette.warning.dark,
              borderRadius: '0.25rem',
              fontWeight:'bold',
              color: '#fff',
              width: '80% !important',
              p: '0.25rem',
              justifyContent: 'center',
            })}

           
          >
            {cell.getValue()}
          </Box>
        ),

        
        enableEditing: false,

      },
      {
        accessorKey: 'user',
        header: 'Auditor / MSID',
        minSize: 250,
        maxSize: 250,
        size: 250,
        muiEditTextFieldProps: ({ row }) => ({
          select: true,
          error: !!validationErrors?.user,
          helperText: validationErrors?.user,
        }),
        Edit: ({ row, cell }) => {
          return (
            <>
              <Autocomplete
                id="disable-clearable"
                disableClearable
                value={row.original.user}
                sx={{
                  display: 'inline-block',
                  '& input': {
                    width: '200px !important',
                    fontSize: '13px !important'
                  },

                }}
                onChange={(event, newValue) => {
                  row.original.user = newValue;
                  setEditedUsers({
                    ...editedUsers,
                    [row.id]: { ...row.original, user: newValue },
                  })
                }
                }
                options={props.userList}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    sx={{
                      padding: '0px !important',
                    }}
                    InputProps={{
                      ...params.InputProps,
                      type: 'search',
                    }}
                  />
                )}
              />
            </>
          )
        }
      },
      {
        accessorFn: (originalRow) => {
          const val1 = originalRow.creation_date;
          return val1 ? new Date(new Date(val1).getTime()) : null;//transforming date first to check null
        },
        header: 'Created Date & Time',
        filterVariant: 'date-range',
        filterFn: (row,columnId,filterValue)=>{
          const rowValue= new Date(new Date(row.getValue(columnId)).getTime()); 
          const [start,end] = filterValue;
          const startDate = start?new Date(start):null;
          const endDate = end?new Date(end):null; 
          if(!start&&!end)
          return true; 
          if(startDate)
         startDate.setHours(0,0,0,0); 
          if(endDate)
          endDate.setHours(23,59,59,999);
          if(startDate&&!endDate)
          return rowValue>=startDate;
          if(!startDate&&endDate)
          return rowValue<=endDate;
          if(startDate&& endDate)
          return rowValue>=startDate && rowValue<=endDate;
        },
        size: 200,
        Cell: ({ cell }) => {
          const val2 = cell.getValue();
          return val2 ? formateDateString(val2) : "";
        }, // convert back to string for display
        enableEditing: false,
      },

      {
        accessorFn: (originalRow) => {
          const val1 = originalRow.claim_completion_last_update_date;
          return val1 ? new Date(new Date(val1).getTime()) : null;//transforming date first to check null
        },
        header: 'Last Update Date & Time',
        filterVariant: 'date-range',
        filterFn: (row,columnId,filterValue)=>{
          const rowValue= new Date(new Date(row.getValue(columnId)).getTime()); 
          const [start,end] = filterValue;
          const startDate = start?new Date(start):null;
          const endDate = end?new Date(end):null; 
          if(!start&&!end)
          return true; 
          if(startDate)
         startDate.setHours(0,0,0,0); 
          if(endDate)
          endDate.setHours(23,59,59,999);
          if(startDate&&!endDate)
          return rowValue>=startDate;
          if(!startDate&&endDate)
          return rowValue<=endDate;
          if(startDate&& endDate)
          return rowValue>=startDate && rowValue<=endDate;
        },
        size: 200,
        Cell: ({ cell }) => {
          const val2 = cell.getValue();
          return val2 ? formateDateString(val2) : "";

        
          
        }, // convert back to string for display

        enableEditing: false,
      },
      {
        accessorKey: 'claim_document',
        header: 'Claim Document',
        minSize: 30,
        maxSize: 30,
        size: 30,
        Cell: ({ row }) => {
          let status = row.original.status;
          return <div>
            {status === "In-Progress" || status === "Pending Review" ? "" : <FileDownloadIcon onClick={() => handleDowloadDocument(row.original.pkey)} style={{ cursor: 'pointer' }} />}
          </div>
        },
        enableEditing: false,
        enableColumnActions: false,
        enableSorting: false,
        enableColumnFilter:false,
      },
      {
        accessorKey: 'file_name', //normal accessorKey
        header: 'File Name',
        minSize: 300,
        maxSize: 300,
        size: 300,
        enableEditing: false,
      },
    ],
    [props.userList, editedUsers, validationErrors],
  );

  if (userRole === 2||userRole===4) {
    columns = columns.filter(col => col.accessorKey !== 'user')
  }
  
  const handleSaveUsers = async () => {
    if (Object.values(validationErrors).some((error) => !!error)) return;
    await updateUsers(Object.values(editedUsers));
    setEditedUsers({});
  };
  function useUpdateUsers() {
    const queryClient = useQueryClient();
    return useMutation({
      mutationFn: async (users) => {
        let isClaimInPendingReview = users.some((claim) => claim.status === "Pending Review");
        if (!isClaimInPendingReview) {
           await callUpdateAuditorAPI(users, msid);
        }
        else {
          if(alertRef.current)
              alertRef.current.showSnackbar("Unable to update auditor for the record(s) which are in Pending Review status! ", "error");
        }
      },
      //client side optimistic update
      onMutate: (newUsers) => {
        queryClient.setQueryData(['users'], (prevUsers) =>
          prevUsers?.map((user) => {
            const newUser = newUsers.find((u) => u.id === user.id);
            return newUser ? newUser : user;
          }),
        );
      },
    });
  }
  const callUpdateAuditorAPI = async (users, msid) => {
    try {
      const token = getToken();
      const header = {
        headers: {
          "Authorization": `Bearer ${token}`,
        },
      };
      alertRef.current.CloseSnackbar();
      const modifyRequest = {
        "data": users.map(users => (
          {
            "id": users.id,
            "key": "" + users.pkey + "",
            "creator": users.user.split('/')[1],
          }
        ))
        ,
        "updatedBy": "" + msid + "",
      }
      AppInsight.trackEvent({ name: `PNA Frontend=>callUpdateAuditorAPI API Call started, msid=> ${msid}`});
      const response = await axios.post(
        process.env.REACT_APP_API_URI + "UpdateAuditor",
        modifyRequest, header
      );
      AppInsight.trackEvent({ name: `PNA Frontend=>callUpdateAuditorAPI API Call completed, msid=> ${msid}`});


      if (response.status === 200 && Object.hasOwn(response.data, 'status') && response.data.status === 1) {
        if(alertRef.current)
            alertRef.current.showSnackbar("Auditor(s) updated successfully!", "success");
      }
      else {
        if(alertRef.current)
            alertRef.current.showSnackbar("Some error occurred while updating the Auditor!", "error");
      }
    }
    catch (error) {
      if(alertRef.current)
          alertRef.current.showSnackbar();
      AppInsight.trackEvent({ name: `PNA Frontend => callUpdateAuditorAPI, msid=>${msid}`, properties: { errorMessage: error.message } });
    }
  }

  const table = useMaterialReactTable({
    columns,
    data, //data must be memoized or stable (useState, useMemo, defined outside of this component, etc.)
    filterFns: {
      myCustomFilterFn: (row, id, filterValue) =>{
      
        let found=false;
        const visibleColumns=table.getAllLeafColumns().filter(column=>column.getIsVisible());
       
         for(const value of visibleColumns){
           const valueId=value.id;
         

           if(valueId==="Last Update Date & Time")
           {

           const lastUpdationDate= row.original.claim_completion_last_update_date!==null?(formateDateString(new Date(row.original.claim_completion_last_update_date))):formateDateString(new Date());
            //const lastUpdationDate= row.original.claim_completion_last_update_date;
          
           if(lastUpdationDate.toLowerCase().includes(filterValue.toLowerCase()))
           {
             found=true;
           }
           }

           else if(valueId==="Created Date & Time")
           {
            // formateDateString(new Date(row.original.creation_date));
             const creationDate=row.original.creation_date!==null?(formateDateString(new Date(row.original.creation_date))):formateDateString(new Date());
            if(creationDate.toLowerCase().includes(filterValue.toLowerCase()))
            {
              found=true;
            }

           }
           
          if(String(row.original[valueId]).toLowerCase().trim().includes(filterValue.toLowerCase().trim())){
             found =true;
           }
         }
        return found;

      }

    },
      
    globalFilterFn: 'myCustomFilterFn',
    enableGlobalFilter:true,
    groupedColumnMode: 'remove',
    layoutMode:'semantic',
    enableEditing: true,
    editDisplayMode: 'table',
    initialState: { density: 'compact' },
    enableDensityToggle: false,
    enableRowSelection: true,
    enableSelectAll: false,
    getRowId: (row) => row.userId, //give each row a more useful id
    onRowSelectionChange: setRowSelection, //connect internal row selection state to your own
    onColumnFiltersChange:setColumnFilters,
    onShowColumnFiltersChange:setShowColumnFilters,
    onColumnVisibilityChange:setColumnVisibility,
    state:{ 
      rowSelection ,
      columnFilters,showColumnFilters,
      columnVisibility,pagination},
    onPaginationChange:handlePagination,
    // enablePagination:true,
    enableColumnFilter:true,
    
    muiTableBodyCellProps: ({ column }) => ({
      //conditionally style pinned columns
      sx: {
        fontSize: '12px',
      },
    }),
    muiTableHeadCellProps: {
      sx: {
        fontSize: {
          xs: '10px',
          sm: '11px',
          md: '11px',
          lg: '12px',
          xl: '13px',
        },
        padding: '5px',

      },
    },
    renderTopToolbarCustomActions: ({ table }) => (
      <Box
        sx={{
          display: 'flex',
          // gap: '16px',
          padding: '0px',
          flexWrap: 'wrap',
        }}
      >
        <Button
          //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
          onClick={handleExportData}
          startIcon={<FileDownloadIcon />}
        >
          Export All Data
        </Button>
        <Button
          disabled={table.getPrePaginationRowModel().rows.length === 0}
          //export all rows, including from the next page, (still respects filtering and sorting)
          onClick={() =>
            handleExportRows(table.getPrePaginationRowModel().rows)
          }
          startIcon={<FileDownloadIcon />}
        >
          Export Filtered Data
        </Button>
        <Button
          disabled={table.getSelectedRowModel().rows.length === 0 || !selectionEnable}
          //export all rows, including from the next page, (still respects filtering and sorting)
          onClick={() => {
            //const rowSelection = table.getState().rowSelection; //read state
            const selectedRows = table.getSelectedRowModel().rows; //or read entire rows
            handleDownloadClaims(selectedRows);
          }}
          // }
          startIcon={<FileDownloadIcon />}
        >
          Export Selected Claim Documents
          </Button>
          <Button onClick={resetState}>Reset Filter</Button>

      </Box>
    ),
    renderBottomToolbarCustomActions: () => (
      <Box sx={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
        {(userRole == 1||userRole==3) && (<Button
          color="success"
          variant="contained"
          onClick={handleSaveUsers}
          disabled={
            Object.keys(editedUsers).length === 0 ||
            Object.values(validationErrors).some((error) => !!error)
          }
        >
          {isUpdatingUsers ? <CircularProgress size={25} /> : 'Save'}
        </Button>)}
        {Object.values(validationErrors).some((error) => !!error) && (
          <Typography color="error">Fix errors before submitting</Typography>
        )}

        {(
          <Button
            calledFrom='delete'
            color="error"
            variant="contained"
            disabled={table.getSelectedRowModel().rows.length === 0 || !selectionEnable}
            onClick={() => {
              // setButtonClicked('buttonDelete');
              // const selectedRows = table.getSelectedRowModel().rows;
              handleSubmit();
            }}
          >
            Delete
          </Button>
        )}
      </Box>
    )

  });
  


  useEffect(() => {
    if (table.getSelectedRowModel().rows.length > 5) {
      setSelectionEnable(false);
      if(alertRef.current)
          alertRef.current.showSnackbar("Unable to download / delete more than 5 records ", "error");
    }
    else {
      setSelectionEnable(true);

    }
  }, [table.getSelectedRowModel().rows]);

  return (
    <div>
      {loader}
      {showPopUp && (
        <Popup
          open={true}
          handleClose={handleClosePopup}
          handleYes={() =>
            handleDeleteClaims(selectedValue)}

          handleNo={handleClosePopup}
          title='Confirmation'
          message='Are you sure you want to delete below Claim# ?'
          warningSignWithMessage="By deleting this claim#, you won't be able to recover the same."
          buttonYes='Yes, Delete'
          buttonNo='No, Cancel'
          severity='Warning'
          value1={val}
          calledfrom='homeTablePopUp'
        >
        </Popup>
      )}
      <SnackBar ref={alertRef} />
      {showTable &&
        <MaterialReactTable 
        table={table}
        />
      }
    </div>


  )
}

export default HomeTable;